import React, {useEffect, useState} from 'react';
import {Button} from 'react-bootstrap';
import '../../Styles/Annotator/AnnotationComponent.css';
import uuid from 'react-uuid';
import $ from 'jquery';
import {cleared, removingAnnotation, updatePTextById} from '../../Utils/helpers';
import {Zap} from 'react-feather';
import {
    setAnnotationDB
} from '../../Database/AnnotationsDAO';
import escapeStringRegexp from 'escape-string-regexp';
import {createAnnotation} from "../../API/annotatorApi";

//import {getOut} from "../../Utils/Common";

function SuggestAnnotationComponent(props) {
    const [suggestionButton, setSuggestionButton] = useState(<></>);
    //const [saveState, setSaveState] = useState(false);
    //const [match, setMatched] = useState([]);

    // Colors for possible annotation types
    const TAG_COLORS = {
        Default: 'rgb(82, 125, 219)',
        Potenzial: 'rgb(5, 165, 107)',
        Hinweis: 'rgb(231, 185, 20)',
        Risiko: 'rgb(239, 3, 3)'
    };

    let matchAndPopulate = async (annotationID) => {
        /***
         * Match the annotation to the mark id
         * @type {Array}
         */
        let annotation = props.annotationData.annotations.find((obj) => obj.unique_id === annotationID);



        let annotationsGetS = annotation;

       [annotationsGetS].map((annotationsGet) => {
            // Populating the annotator form component
            $('#norm').val(annotationsGet.norm);
            $('#advice').val(annotationsGet.advice);
            $('#agl').val(annotationsGet.anspruch);
            $('#kommentor').val(annotationsGet.kommentor);
            $('#category').val(annotationsGet.type);
            $('#formel').val(annotationsGet.formula);
            $('#ursache').val(annotationsGet.Annotation);
        });

        return annotationsGetS;
    };

    async function getCurrentPositionText(rowID) {

        return document.getElementById(rowID).innerHTML

    }

    let onValidate = async (_el, id) => {
        /***
         * Validating the annotation if it is legit
         * @type {Array}
         */
        cleared();

        let matched = await matchAndPopulate(id).then(function (result) {
            return JSON.stringify(result);
        });
        matched = JSON.parse(matched);
        // make the document ready before the dialogue initiates.
        setTimeout(
            async function () {
                if (confirm('Should we accept this annotation?') === true) {
                    // Assign the actual color to the highlight
                    let mark = document.getElementById(id);

                    // we update the IndexedDB state for unresolved annotation
                    let resolveAnnotation = matched;
                    let annotationID = matched.unique_id;
                    resolveAnnotation['type'] = resolveAnnotation.suggested;

                    /* check for type key */
                    if ("type" in resolveAnnotation) {
                        delete resolveAnnotation.suggested;
                        mark.style.backgroundColor =
                            TAG_COLORS[matched.type];
                        /* after we accept we remove the class attribute inValidation which defined to each non
                                                            validated annotation when mark was created */
                        mark.removeAttribute('class');
                        setAnnotationDB(resolveAnnotation);
                        localStorage.setItem('annotationID', annotationID);
                        // set the lv document
                        let rowID = matched.rowId;
                        let ID = matched.unique_id;
                        //let lvID = localStorage.getItem("parsedlv_id");
                        let lvID = props.parsedlv_id
                        let annotation = matched;
                        annotation['mengeUnitValue'] = ""

                        let positionText = await getCurrentPositionText(rowID)
                        if (positionText) {
                            annotation['position'] = []
                            await createAnnotation(lvID, ID, rowID.toString(), annotation, positionText)
                            let state = props.annotationData
                            let updatedDocument = updatePTextById(state.lv_document, rowID, positionText);
                            let exists = state.annotations.some((obj) => obj.unique_id === ID);
                            if (exists) {
                                let newState = state.annotations.filter((obj) => obj.unique_id !== ID);
                                newState.push(annotation)
                                let update = {annotations: newState, lv_document: updatedDocument}
                                props.setAnnotationData(update)
                            } else {
                                state.annotations.push(annotation)
                                let update = {annotations: state.annotations, lv_document: updatedDocument}
                                props.setAnnotationData(update)
                            }

                        }
                    } else {

                        alert("Please delete and do the current annotation again.")
                    }

                } else {
                    let state = await props.annotationData
                    await removingAnnotation(id, state,props.parsedlv_id);
                    let newData = state.annotations.filter((obj) => obj.unique_id !== id);
                    let newState = state
                    newState.annotations = newData
                    props.setAnnotationData(newState)

                }
            }.bind(this),
            500
        );
    };

    // function saveAITrackingData(a, result) {
    //     if (a.includes(result[0].annotation_data.norm.trim())) {
    //         let rowid = result[0].annotation_data.row_id;
    //         let allAI = getAITracking();
    //         allAI.then(function (result1) {
    //             let aiTrack = result1[0].trackingInfo;
    //             if (!aiTrack.tracking_info[rowid]) {
    //                 aiTrack.tracking_info.rowid = {tp: [], fp: [], fn: []};
    //                 aiTrack.tracking_info.rowid.fn.push(result[0]);
    //             } else {
    //                 if (
    //                     !aiTrack.tracking_info.rowid.fp.some(
    //                         (e) =>
    //                             e.norm === result[0].annotation_data.norm &&
    //                             e.annotation === result[0].annotation_data.annotation &&
    //                             e.advice === result[0].annotation_data.advice
    //                     )
    //                 ) {
    //                     aiTrack.tracking_info.rowid.fn.push(result[0]);
    //                 }
    //             }
    //             saveAITracking({
    //                 lv_id: aiTrack.lv_id,
    //                 tracking_info: aiTrack.tracking_info
    //             });
    //         });
    //     }
    // }

    /***
     * The function to highlight the consecutive mark highlights for sugested annotations.
     * @param $position position Element (p tag)
     * @param annotations Text we need to highlight
     * @param positionID type: object, position object of the LV ( Example: short_text as hinweis, long_text etc. )
     * @param positionMenge Menge value at respective position
     * @param caseSensitive Whether case sensitivity should be taken care or not.
     */
        // eslint-disable-next-line no-unused-vars
    let highlightSuggestedAnnotation = ($position, annotations, positionID, positionMenge, caseSensitive = false) => {
            const flags = caseSensitive ? 'gi' : 'g';
            // we map all annotations text to annotations ids to later match them.
            let map = {};
            //we create an array of texts to be matched
            let textAnnotations = [];
            annotations.forEach(function (obj) {
                // we first escape the special characters in string to not to interfere with regular expressions
                const escapedString = escapeStringRegexp(obj.Annotation);
                map[obj.Annotation] = obj.unique_id;
                textAnnotations.push(escapedString);
            });
            textAnnotations.sort((a, b) => b.length - a.length);
            Array.from($position.childNodes).forEach((child) => {
                // Avoid overriding  the highlights
                if (child.parentNode.nodeName !== 'MARK') {
                    const keywordRegex = RegExp(textAnnotations.join('|'), flags);
                    if (child.nodeType !== 3) {
                        // not a text node
                        highlightSuggestedAnnotation(child, annotations, positionID, positionMenge, caseSensitive);
                    } else if (keywordRegex.test(child.textContent)) {
                        const frag = document.createDocumentFragment();
                        let lastIdx = 0;
                        child.textContent.replace(keywordRegex, async (match, idx) => {
                            const part = document.createTextNode(child.textContent.slice(lastIdx, idx));
                            let newAnnotationID = 'sug_' + uuid();
                            const highlighted = document.createElement('mark');
                            highlighted.setAttribute('id', newAnnotationID);
                            highlighted.setAttribute('name', 'current');
                            highlighted.setAttribute('style', 'background-color: lightgrey;');
                            highlighted.classList.add('inValidation');
                            highlighted.textContent = match;
                            frag.appendChild(part);
                            frag.appendChild(highlighted);
                            lastIdx = idx + match.length;

                            //Original state indexedDB before suggested annotations were created
                            let annotationsData = props.annotationData.annotations;


                            //find the object where the unique id is the same to extract the advice
                            let elementPos = annotations
                                .map(function (x) {
                                    return x.unique_id;
                                })
                                .indexOf(map[match]);
                            let matchedAnnotation = annotations[elementPos];
                            //We create new annotation from the suggested
                            let newAnnot = {
                                unique_id: newAnnotationID,
                                ord: positionID.ref,
                                rowId: positionID.row_id,
                                Annotation: match,
                                adviceID: matchedAnnotation.adviceID,
                                law: matchedAnnotation.law,
                                norm: matchedAnnotation.norm,
                                value: '0',
                                advice: matchedAnnotation.advice,
                                kommentor: matchedAnnotation.kommentor,
                                formula: matchedAnnotation.formula,
                                type: 'Unresolved',
                                suggested: matchedAnnotation.type,
                                menge: positionMenge,
                                timestamp: Date.now(),
                                short_text: positionID.hinweis,
                                dgl_ref: positionID.dgl_ref,
                                report_ref: positionID.report_ref
                            };
                            // If already the annotation dont exist (when indexOf return -1) we add a new annotation
                            if (annotationsData.indexOf(newAnnot) === -1) {
                                //await setAnnotationDB(newAnnot);
                                // set the lv document
                                //let lvDocument = getCurrentStateOfLvDocument();
                                //removeLVDocumentDB();
                                //setLVDocumentDB(lvDocument);
                                let state = props.annotationData
                                state.annotations.push(newAnnot)
                                props.setAnnotationData(state)
                                // add to false negative
                                // let testForAI = getAnnotationsDB(newAnnotationID);
                                // testForAI.then(function (result) {
                                //     const a = [
                                //         'Nicht Neutral',
                                //         'beschilderung',
                                //         'Unklar',
                                //         'Site Visitation',
                                //         'stundenlohnarbeiten'
                                //     ];
                                //     //saveAITrackingData(a, result);
                                // });
                            }
                        });
                        const end = document.createTextNode(child.textContent.slice(lastIdx));
                        frag.appendChild(end);
                        child.parentNode.replaceChild(frag, child);
                    }
                }
            });
        };

    /**
     * @param positionID type: object, position object of the LV ( Example: short_text as hinweis, long_text etc. )
     * @param annotations The complete annotations for respective LV.
     */
    let renderAnnotations = (positionID, annotations) => {
        /***
         * Create mark elements for the suggested annotations
         * @type {HTMLElement | null}
         */
        let $inputText = document.getElementById(positionID.row_id);
        //Retrieve menge at the respective posiition
        let parentDIV = $inputText.parentNode;
        let parentTextTableCell = parentDIV.parentNode;
        let parentMengeTableCell = parentTextTableCell.nextSibling;
        let positionMenge = parentMengeTableCell.textContent.trim();
        highlightSuggestedAnnotation($inputText, annotations, positionID, positionMenge);
    };

    /**
     * @param elem Current element on html document
     * @param positionID type: object, position object of the LV ( Example: short_text as hinweis, long_text, menge etc. )
     * @returns {Promise<void>}
     */
    let makeSuggestions = async (elem, positionID) => {
        /***
         * Invoke the mark suggestions
         */
        elem.preventDefault();

        let annotations = props.annotationData.annotations;

        // when there no annotation we warn the user
        if (annotations.length < 1 || annotations === undefined) {
            alert('Warning: There are no annotations to suggest!');
        } else {
            let currentAnnotations = annotations;
            let uniqueAnnotations = [];
            // find unique elements from the array of annotations and consider only the last the occurrences of the annotation.
            currentAnnotations.forEach(function (item) {
                let existing = uniqueAnnotations.filter(function (v) {
                    return v.Annotation === item.Annotation;
                });
                if (existing.length) {
                    // We consider the last occurrence of given object
                    let existingIndex = uniqueAnnotations.lastIndexOf(existing[0]);
                    uniqueAnnotations[existingIndex].value = uniqueAnnotations[existingIndex].value.concat(item.value);
                } else {
                    if (typeof item.value === 'string') item.value = [item.value];
                    uniqueAnnotations.push(item);
                }
            });

            // Renders the suggested annotations
            //if (document.querySelectorAll('*[class="inValidation"]').length === 0) {
            renderAnnotations(positionID, uniqueAnnotations);
            // } else {
            //     alert('You have unresolved suggested annotations, please first resolve them.');
            // }
            //let allAnnotations = JSON.parse(localStorage.annotationsData);
            // Adding a event listener over the mark elements of the suggested annotations.
            document.querySelectorAll('*[name="current"]').forEach(async function (mark) {
                let elemID = mark.id;
                mark.addEventListener('click', (el) => onValidate(el, elemID), true);
                // So to only trigger event once and do not add multiple listeners for same mark element

                mark.removeAttribute('name');
            });
        }
    };

    useEffect(() => {
        const makeSuggestionsButton = (
            <Button
                size="sm"
                className="handwai-btn-report"
                id="suggest"
                onClick={(el) => {
                    makeSuggestions(el, props.positionID).then((r) => r);
                }}
            >
                <Zap/> Suggest
            </Button>
        );

        setSuggestionButton(makeSuggestionsButton);
    }, []);

    return <>{suggestionButton}</>;
}

export default SuggestAnnotationComponent;
